// extracted by mini-css-extract-plugin
module.exports = {"SearchResultsPage":"styles_SearchResultsPage__GOSO5","SearchResultsPage__searchField":"styles_SearchResultsPage__searchField__tpMA4"};